// mixins/globalMixin.js

import { pageViewTrack } from '../js_sdk/Sensorsdata/pageview';

export default {
  onShow() {
    this.$Sensors.pageViewTrack();
  },
};
